"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentsPages = exports.getPagesForBlock = void 0;
var _player = require("../../../selectors/player.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getPagesForBlock = exports.getPagesForBlock = function getPagesForBlock(state) {
  return function () {
    var parentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (parentId === 0) {
      return (0, _player.getPages)(state);
    }
    var adjustedState = _objectSpread(_objectSpread({}, state), {}, {
      playingParentId: parentId
    });
    return (0, _player.getPages)(adjustedState);
  };
};
var getParentsPages = exports.getParentsPages = function getParentsPages(state) {
  return function () {
    var parentId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var links = (0, _player.getLinks)(state);
    var pageFirstElementId = (0, _player.getActualPageFirstElementId)(state);
    var pages = [];
    function getSimplePages(id) {
      var elementLink = links[id];
      var page = {
        state: 'prev'
      };
      var result = [];
      elementLink.children.forEach(function (child) {
        var childLink = links[child];
        if (childLink.type === 'pageBreak') {
          return;
        }
        if (child === pageFirstElementId) {
          page = {
            state: 'current'
          };
        } else if (childLink.allChildren && childLink.allChildren.includes(pageFirstElementId)) {
          page = {
            state: 'current'
          };
        } else if (page.state === 'current') {
          page = {
            state: 'next'
          };
        }
        result.push(_objectSpread(_objectSpread({}, page), {}, {
          settings: childLink.settings
        }));
      });
      pages.push(result);
      if (elementLink.parents) {
        getSimplePages(elementLink.parents[0]);
      }
    }
    getSimplePages(parentId);
    return pages;
  };
};